// extracted by mini-css-extract-plugin
export default {"title":"CardTitle_title__QTUy+","link":"CardTitle_link__T1hKu"};